import { render, staticRenderFns } from "./component-b80a8704.vue?vue&type=template&id=65830eec&scoped=true&"
import script from "./component-b80a8704.vue?vue&type=script&lang=js&"
export * from "./component-b80a8704.vue?vue&type=script&lang=js&"
import style0 from "./component-b80a8704.vue?vue&type=style&index=0&id=65830eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65830eec",
  null
  
)

export default component.exports